import QuickGroupDtcs from './QuickGroupDtcs';
export default QuickGroupDtcs;


// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickHealth/QuickGroupDtcs/index.js